import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

const CloseButton = ({ isOpen, close, side = 'tr' }) => (
  <Button
    color="darkgray"
    size="lg"
    onClick={close}
    className="guide-close m-4 border-white border-lg"
    data-open={isOpen}
    data-side={side}
  >
    Close
  </Button>
);

const mapStateToProps = (store) => ({
  isOpen: store.guide.isOpen,
});

const mapDispatchToProps = {
  close: () => ({ type: 'CLOSE_GUIDE' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CloseButton);
